import React from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
const API_URL = process.env.REACT_APP_API_URL_EC2;

const Register = () => {
  const [fname, setfname] = useState();
  const [lname, setlname] = useState();
  const [number, setnumber] = useState();
  const [password, setpassword] = useState();
  const [email, setemail] = useState();
  const [county, setcounty] = useState();
  const [address, setaddress] = useState();

  const styles = {
    formContainer: {
      border: "2px solid rgba(0, 0, 0, 0.7)", // Faded black border with 40% opacity
      borderRadius: "8px", // Rounded corners
      padding: "30px", // Padding inside form
      backgroundColor: "#f8f9fa", // Light gray background
    },
    inputField: {
      borderRadius: "4px", // Rounded corners for input
      padding: "10px", // Padding inside input
    },
  };

  const validateFields = () => {
    let messages = [];
    if (!fname) messages.push("First name is required.");
    if (!lname) messages.push("Last name is required.");
    if (!number || !/^\d{10}$/.test(number))
      messages.push("Valid 10-digit number is required.");
    if (!password || password.length < 6)
      messages.push("Password must be at least 6 characters.");
    if (!email || !/\S+@\S+\.\S+/.test(email))
      messages.push("Valid email is required.");
    if (!county) messages.push("County is required.");
    if (!address) messages.push("Address is required.");

    return messages;
  };

  const onsubmit = async (e) => {
    e.preventDefault();
    const validationMessages = validateFields();
    if (validationMessages.length > 0) {
      Swal.fire({
        icon: "error",
        title: "Validation Errors",
        html: validationMessages.join("<br>"),
      });
      return;
    }

    try {
      const passwordStrengthResponse = await axios.post(
        "http://pscapi-env.eba-c6kbzpsc.us-east-1.elasticbeanstalk.com/api/user/check",
        { password : password }
      );
  
      const { strength, feedback } = passwordStrengthResponse.data;
  
      // Step 2: Validate password strength
      if (strength < 5) {
        Swal.fire({
          icon: "error",
          title: "Weak Password",
          html: feedback.join("<br>"), // Display feedback messages
        });
        return;
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error Checking Password Strength",
        text: "Could not verify password strength. Please try again later.",
      });
      return;
    }

    try {
      let response = await axios.post(`${API_URL}/api/registerUser`, {
        fname: fname,
        lname: lname,
        number: number,
        password: password,
        email: email,
        address: address,
        county: county,
        Imageurl: "",
        categorypreference1: "",
        categorypreference2: "",
        isAdmin: "false",
      });

      console.log(response);
      if (response.data.success) {
        Swal.fire({
          icon: "success",
          title: "Registered SuccessFully!",
          text: response.data.message,
          confirmButtonText: "OK",
        }).then(() => {
          setfname("");
          setlname("");
          setnumber("");
          setpassword("");
          setemail("");
          setcounty("");
          setaddress("");
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Registration Failed",
          text: response.data.message,
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong! Please try again later.",
      });
    }
  };

  return (
    <div>
      <section id="contact" className="contact">
        <div className="container">
          <div className="row" style={{ paddingTop: "50px" }}>
            <div
              className="col-lg-4 aos-init aos-animate"
              data-aos="fade-right"
            >
              <div className="section-title">
                <h2>Add User</h2>
                <p>Register HERE</p>
              </div>
            </div>
            <div className="col-lg-8 aos-init aos-animate" data-aos="fade-left">
              <div className="php-email-form mt-4" style={styles.formContainer}>
                <div className="row">
                  <div className="col-md-6 form-group">
                    <Form.Label style={{ fontWeight: "bold" }}>
                      First Name
                    </Form.Label>
                    <input
                      type="text"
                      name="fname"
                      className="form-control"
                      id="fname"
                      placeholder="Your Name"
                      value={fname}
                      onChange={(e) => setfname(e.target.value)}
                      required=""
                      style={styles.inputField}
                    />
                  </div>

                  <div className="col-md-6 form-group mt-3 mt-md-0">
                    <Form.Label style={{ fontWeight: "bold" }}>
                      Last Name
                    </Form.Label>
                    <input
                      type="text"
                      className="form-control"
                      name="lname"
                      id="lname"
                      placeholder="Your Last Name"
                      value={lname}
                      onChange={(e) => setlname(e.target.value)}
                      required=""
                      style={styles.inputField}
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6 form-group mt-3 mt-md-0">
                    <Form.Label style={{ fontWeight: "bold" }}>
                      Mobile Number
                    </Form.Label>
                    <input
                      type="number"
                      className="form-control"
                      name="number"
                      placeholder="Your number"
                      value={number}
                      onChange={(e) => setnumber(e.target.value)}
                      required=""
                      style={styles.inputField}
                    />
                  </div>

                  <div className="col-md-6 form-group mt-3 mt-md-0">
                    <Form.Label style={{ fontWeight: "bold" }}>
                      Password
                    </Form.Label>
                    <input
                      type="password"
                      className="form-control"
                      name="password"
                      id="password"
                      placeholder="Your password"
                      value={password}
                      onChange={(e) => setpassword(e.target.value)}
                      required=""
                      style={styles.inputField}
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6 form-group mt-3 mt-md-0">
                    <Form.Label style={{ fontWeight: "bold" }}>
                      Email
                    </Form.Label>
                    <input
                      type="email"
                      className="form-control"
                      name="email"
                      id="email"
                      placeholder="Your email"
                      value={email}
                      onChange={(e) => setemail(e.target.value)}
                      required=""
                      style={styles.inputField}
                    />
                  </div>

                  <div className="col-md-6 form-group mt-3 mt-md-0">
                    <Form.Label style={{ fontWeight: "bold" }}>
                      County
                    </Form.Label>
                    <input
                      type="text"
                      className="form-control"
                      name="county"
                      id="county"
                      placeholder="Your County"
                      value={county}
                      onChange={(e) => setcounty(e.target.value)}
                      required=""
                      style={styles.inputField}
                    />
                  </div>
                </div>

                <div className="form-group mt-3 mt-md-0">
                  <Form.Label style={{ fontWeight: "bold" }}>
                    Address
                  </Form.Label>
                  <input
                    type="text"
                    className="form-control"
                    name="address"
                    id="address"
                    placeholder="Address"
                    value={address}
                    onChange={(e) => setaddress(e.target.value)}
                    required=""
                    style={styles.inputField}
                  />
                </div>

                <div className="text-center" style={{ marginTop: "20px" }}>
                  <Button onClick={onsubmit}>Register</Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Register;
